import { supabasePlugin } from "@/plugins/supabase.ts";

async function sendEmail(dataObj) {
  // console.log("dataObj :", dataObj);
  // return

  return await supabasePlugin.client.functions.invoke("send-email", {
    body: {
      from: dataObj.from,
      to: dataObj.to,
      subject: dataObj.subject,
      body: dataObj.body,
      attachments: dataObj.attachments,
      cc: dataObj.cc
    }
  });
}

async function getManagerInfo(userId) {
  return await supabasePlugin.client.functions.invoke("get-manager-info", {
    body: {
      userId
    }
  });
}

export default {
  sendEmail,
  getManagerInfo
};
